// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__NotFound__2Kzj5{display:flex;justify-content:center;align-items:center;padding:56px}", ""]);
// Exports
exports.locals = {
	"NotFound": "styles-module__NotFound__2Kzj5"
};
export default exports;
